var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{key:_vm.buttonKey,attrs:{"disabled":_vm.loadingState,"type":"button"},on:{"~click":function($event){return _vm.handleClick($event)}}},[_vm._t("default",[_vm._v("Button ")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }